// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalBodyText-root-77fa507930304baf6987e2a8114ec497"};